/**
 * Copyright (C) Sitevision 2002-2023, all rights reserved
 */
import { hasPortlet } from '../../util/findPortlets';

if (hasPortlet('sv-searchform2-portlet')) {
  import(/* webpackChunkName: "searchform2-portlet" */ './plugins-slim');
}
